import { types } from '../constants'

const index = {
  pending: `${types.list}_PENDING`,
  fulfilled: `${types.list}_FULFILLED`,
  rejected: `${types.list}_REJECTED`,
  setPage: types.page,
  setPerPage: types.perPage
}

const reducerKey = 'product'

export const list = {
  [index.pending]: ({ draft }) => {
    draft[reducerKey].list.loading = true
    draft[reducerKey].list.error = null
  },
  [index.fulfilled]: ({ draft, action }) => {
    draft[reducerKey].list.data = action.payload.data

    draft[reducerKey].list.pages = action.payload.pages
    draft[reducerKey].list.total = action.payload.total
    draft[reducerKey].list.page = action.payload.page

    draft[reducerKey].list.loading = false
    draft[reducerKey].list.error = null
  },
  [index.rejected]: ({ draft, action }) => {
    draft[reducerKey].list.loading = false
    draft[reducerKey].list.error = action.payload
  },
  [index.setPage]: ({ draft, action }) => {
    draft[reducerKey].list.page = action.payload
  },
  [index.setPerPage]: ({ draft, action }) => {
    draft[reducerKey].list.perPage = action.payload
  }
}
